import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { showConfirmModal } from '../../redux/actions';
import { MODAL_CONFIRM_DISCARD_CHANGES, userRoles } from '../../constants/constants';

/**
 * @description A react component which will receive an `onClick`-prop.
 * It will display a modal if there are any unsaved changes,
 * with the options to cancel or confirm discarding the changes and carry on,
 * i.e. to proceed with the action
 * @param {React.Component} WrappedComponent
 * @param {function} reduxAction Which reduxAction you would like to be
 * triggerd when clicking on `WrappedComponent`
 * or - if there are any unsaved changes -
 * on the confirm button in the modal.
*/
const addUnsavedChangesWarnPreAction = (WrappedComponent, reduxAction) => {
  class WithUnsavedChangesWarn extends PureComponent {

    getMessagesForAnyUnsavedChanges = () => {
      const {
        unsavedAnalyzes,
        cases,
        specimens,
        allPathologists,
        auth,
      } = this.props;
      return unsavedAnalyzes.map(({ formId }) => {
        let message;
        const pathologistId = formId.substring(formId.indexOf('pathologist:') + 12);
        const isCaseAnalysis = formId.startsWith('case');

        if (isCaseAnalysis) {
          const caseId = formId.substring(formId.indexOf('case:') + 5, formId.indexOf(','));
          const unsavedCaseAnalysis = cases.find(c => c._id === caseId);
          const { firstName, lastName } = unsavedCaseAnalysis.partOneGeneralInformation;
          message = `- case analysis of "${firstName} ${lastName}"`;
        } else {
          const specimenId = formId.substring(formId.indexOf('specimen:') + 9, formId.indexOf(','));
          const unsavedSpecimenAnalysis = specimens.find(s => s._id === specimenId);
          try {
            message = `- specimen (id ${unsavedSpecimenAnalysis.id}) analysis`;
          }
          catch (error) {
            console.error("Error on unsaved message:", error);
            message = `- specimen analysis`;
          }
            
        }
        if (auth.user.role === userRoles.admin) {
          const pathologist = allPathologists.find(p => p._id === pathologistId);
          message += ` by pathologist "${pathologist.name}"`;
        }
        return message;
      });
    }


    displayModal = (messages, actionToDispatch) => {
      const {
        showConfirmModal: dispatchShowConfirmModal,
      } = this.props;

      dispatchShowConfirmModal(MODAL_CONFIRM_DISCARD_CHANGES, {
        onConfirm: () => actionToDispatch(),
        message: messages,
      });
    }

    handleAction = (actionToDispatch, hasUnsavedChanges) => {
      return hasUnsavedChanges
        ? this.displayModal(this.getMessagesForAnyUnsavedChanges(), actionToDispatch)
        : actionToDispatch();
    }

    render() {
      const { actionToDispatch, hasUnsavedChanges } = this.props;
      return (
        <WrappedComponent
          onClick={() => this.handleAction(actionToDispatch, hasUnsavedChanges)}
        />
      );
    }
  }
  /**
   * @todo (11.01.19) Atm, the check for unsaved changes is only
   * adjusted for when signed in user has role `val_technician` or
   * `val_pathologist` (...not in a proper role-check way, though).
   * Potential unsaved changes during validation study:
   * - `val_technician` ->`caseGeneralInformation`
   * - `val_pathologist`: -> `caseSpecimenForm`
   */
  /*   const mapStateToProps = state => ({
      editableResources: {
        generalCaseInformation: {
          isUnsaved: isDirty('caseGeneralInformation')(state),
          message: 'Clinical information of currently selected case',
        },
        specimenAnalysis: {
          isUnsaved: isDirty('caseSpecimenForm')(state),
          message: 'Analysis of currently selected specimen',
        },
      },
    }); */
  const mapStateToProps = ({ _case, auth }) => {
    const { unsavedAnalyzes, cases, specimens, allPathologists } = _case;

    if (unsavedAnalyzes.length === 0) {
      return { hasUnsavedChanges: false };
    }

    return { hasUnsavedChanges: true, unsavedAnalyzes, cases, specimens, allPathologists, auth };
  };

  const mapDispatchToProps = Object.assign({ showConfirmModal }, { actionToDispatch: reduxAction });

  return connect(
    mapStateToProps,
    mapDispatchToProps,
  )(WithUnsavedChangesWarn);
};

export default addUnsavedChangesWarnPreAction;
